import { render, staticRenderFns } from "./unreliable_projects.vue?vue&type=template&id=0cf5ca86&"
import script from "./unreliable_projects.vue?vue&type=script&lang=js&"
export * from "./unreliable_projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf5ca86')) {
      api.createRecord('0cf5ca86', component.options)
    } else {
      api.reload('0cf5ca86', component.options)
    }
    module.hot.accept("./unreliable_projects.vue?vue&type=template&id=0cf5ca86&", function () {
      api.rerender('0cf5ca86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/unreliable_projects.vue"
export default component.exports